import React, { useState, useCallback } from 'react';
import Form from '@core/js/components/common/Form';
import { useTranslations } from '@core/js/hooks/i18n';
import { Button } from '@core/js/components/common/Button';
import { Input } from '@core/js/components/common/Fields/Input';
import { required } from '@core/js/utils/Validation/validationRules';
import { useLoginPopup } from '@core/js/components/popups/LoginPopup';
import { ErrorMessage } from '@core/js/components/common/ErrorMessage';

import { usePinVerification } from '@core/js/components/popups/PinVerificationPopup/components/hooks';

import style from '@core/js/components/popups/PinVerificationPopup/components/PinVerification.scss';

const validationConfig = {
    pin: [
        required({ error: 'playtech.mobile.system.pinVerification.popup.pin.tooltip.required' })
    ]
};

// TODO need removed this file after Core Merge 24.7.4.0

export const PinVerification = ({ isSSO, onSuccess, onClose }) => {
    const [error, setError] = useState();
    const showLoginPopup = useLoginPopup();
    const pinVerification = usePinVerification({ onSuccess, onClose, setError });

    const returnToLogin = useCallback((event) => {
        event.preventDefault();
        onClose();

        if (isSSO) {
            showLoginPopup();
        }
    }, [showLoginPopup, onClose, isSSO]);

    const t = useTranslations('playtech.mobile.system.pinVerification.popup.');

    return <Form
        onSubmit={pinVerification}
        validationConfig={validationConfig}
        render={({ submitting, handleSubmit }) => (
            <div>
                <form
                    onSubmit={event => event.preventDefault()} /* TotalCasino changes */
                >
                    {error && (
                        <ErrorMessage
                            error={error}
                            animate={true}
                            className={style.error}
                        />
                    )}
                    <span className={style.description}>{t('title')}</span>
                    <Input
                        name="pin"
                        type="password"
                        className={style.control}
                        placeholder={t('pin.placeholder')}
                        aria-label={t(['pin.placeholder', 'playtech.mobile.system.input.aria-label'])}
                    />
                    <span>
                        {t('forgotPin')} <a href="#" onClick={returnToLogin}>{t('return')}</a>
                    </span>
                    <div className={style.formActions}>
                        <Button
                            type="button"
                            color="negative"
                            onClick={onClose}
                            className={style.btn}
                        >
                            {t('playtech.mobile.system.cancel.button.title')}
                        </Button>
                        <Button
                            type="button" /* TotalCasino changes */
                            className={style.btn}
                            disabled={submitting}
                            onClick={handleSubmit} /* TotalCasino changes */
                        >
                            {t('button.verify')}
                        </Button>
                    </div>
                </form>
            </div>
        )}
    />;
};
